import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgCircleComponent } from './svgcircle.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgCircleComponent],
  exports: [SvgCircleComponent]
})
export class SvgCircleModule { }
